export default "__VITE_ASSET__BSI5osBD__"